(() => {
  const mobileMedia = window.matchMedia('(max-width: 749px)');

  const initializeAboutSection = (root) => {
    const disclosures = Array.from(root.querySelectorAll('[data-cs-about-details]'));

    const syncDisclosureState = () => {
      disclosures.forEach((disclosure) => {
        disclosure.open = !mobileMedia.matches;
      });
    };

    syncDisclosureState();

    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', syncDisclosureState);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(syncDisclosureState);
    }
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-cs-about]').forEach(initializeAboutSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-cs-about]') || event.target.closest('[data-cs-about]');
    if (root) initializeAboutSection(root);
  });
})();
